<template>
  <Layout :removePadding="true">
    <v-progress-circular
      v-if="!userData"
      indeterminate
      color="primary"
      class="absolute-center"
    ></v-progress-circular>
    <div v-else>
      <BalanceData
        class="sticky-balance"
        :balance="userData.balance"
        :tokens="userData.tokens"
        :routeNames="routeNames"
      ></BalanceData>
      <v-main style="margin-top: 12rem">
        <v-container fluid class="px-8 pt-15">
          <BigButton
            v-if="availablePayment"
            :label="$t('main.recharge')"
            icon="add_circle"
            class="mb-3"
            @click.native="$router.push({ name: routeNames.RECHARGE })"
          ></BigButton>
          <BigButton
            :label="$t('main.transactions')"
            icon="wysiwyg"
            class="mb-3"
            @click.native="
              $router.push({
                name: routeNames.TRANSACTIONS,
                params: { showTransactionsWarningModal: true },
              })
            "
          ></BigButton>
          <div class="tooltip-refund mb-3" onk>
            <BigButton
              :label="$t('main.balance_return')"
              :visible="allowRefunds && availableRefunds.length > 0"
              icon="attach_money"
              class="mt-3"
              :disabled="!isRefundAvailable || isRefundPending"
              :msg_disabled="
                isRefundPending
                  ? null
                  : $t('main.balance_return_disabled_msg', {
                      date: refundAvailableDate,
                    })
              "
              @click.native="goToRefundProcess()"
            ></BigButton>
            <v-tooltip
              v-model="refundTooltip"
              v-if="allowRefunds"
              open-on-click
              :open-on-hover="false"
              :close-delay="10000"
              left
              color="#474747"
              :max-width="350"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="icon-tooltip" v-bind="attrs" v-on="on">
                  <v-icon color="secondary" size="30">info</v-icon>
                </div>
              </template>
              <span>{{ refundMessage }}</span>
            </v-tooltip>
          </div>
        </v-container>
      </v-main>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { RequestService } from "../services/request.service";
import errorManager from "../services/error.manager";
import { mapState } from "vuex";
import { EventBus } from "../services/event-bus";
import { Message } from "../entities/app-entities/Message";
const requestService = new RequestService();

export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      userData: null,
      refund: null,
      refundTooltip: false,
      availablePayment: true
    };
  },
  components: {
    Layout,
    BalanceData: require("@/components/BalanceData").default,
    BigButton: require("@/components/form-elements/BigButton").default,
  },
  computed: {
    ...mapState({
      refundAvailable: (state) =>
        state.customization.customization.economics.refund_available,
      customization: (state) => state.customization.customization,
      allowRefunds: (state) => { return (state.customization.customization.allow_refunds !== undefined) ? state.customization.customization.allow_refunds : true },
      availableRefunds: (state) => { return (state.customization.customization.available_refunds !== undefined) ? state.customization.customization.available_refunds : [] }
    }),
    refundAvailableDate() {
      const date = moment(this.refundAvailable).tz("UTC");
      return date.format("DD/MM/YYYY hh:mm");
    },
    isRefundPending() {
      return this.refund && this.refund.status === "PENDING" ? true : false;
    },
    isRefundAvailable() {
      return window.moment(this.refundAvailable).isBefore(new Date());
    },
    refundMessage() {
      return this.customization.economics.refund_unavailable_description.find(
        (objeto) => objeto.locale === this.$i18n.locale
      )
        ? this.customization.economics.refund_unavailable_description.find(
            (objeto) => objeto.locale === this.$i18n.locale
          ).content
        : this.customization.economics.refund_unavailable_description[0]
            .content;
    }
  },
  methods: {
    getUserData() {
      const context = this;
      requestService
        .getUserData(context)
        .then((userData) => {
          context.userData = userData;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });

      requestService
        .getRefunds(context)
        .then(
          (refund) => (context.refund = refund != undefined ? refund : null)
        )
        .catch((error) => {
          if (error.status == 404) {
            context.refund = null;
          } else {
            errorManager.manageError(context, error);
          }
        });
    },
    goToRefundProcess() {  
      if (this.isRefundAvailable && !this.isRefundPending && this.userData.balance !== 0){
        if (this.availableRefunds.includes('FORM') && this.availableRefunds.includes('USER_WEBAPP')) {
          if (this.userData.balance === this.userData.refundableBalance){
            this.$router.push({ name: this.routeNames.BALANCE_REFUND })
          } else {
            this.goToRefundForm()
          }
        } else if (this.availableRefunds.includes('FORM')) {
          this.goToRefundForm()
        } else if (this.availableRefunds.includes('USER_WEBAPP')) {
          this.$router.push({ name: this.routeNames.BALANCE_REFUND })
        }
      }
      if (this.userData.balance === 0) {
        this.sendMessage(this.$t("error.user_not_balance"))
      }
    },
    goToRefundForm(){
      const tagOrUserId = this.userData.tag_id || this.userData.id
      if (window.location.href.includes('webapp-legacy-sandbox.go-fun.cloud')){
          window.open('https://d3df6co520lkqy.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v1 sandbox
        } else if (window.location.href.includes('webapp-sandbox.go-fun.cloud')){
          window.open('https://d1a0oy26cjhfg8.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v2 sandbox
        } else if (window.location.href.includes('ego.easygoband.com')){
          window.open('https://d37o4jix7u2tp7.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v1 prod
        } else if (window.location.href.includes('webapp.go-fun.cloud')){
          window.open('https://d1ymjexbz9rp2q.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v2 prod
        }
    },
    getEconomics() {
      const context = this;
      this.$store.dispatch("getEconomics", context).then((economics) => {
        context.availablePayment = economics.mit.enabled 
        || economics.paylands.enabled 
        || economics.mercadopago.enabled
      });
    },
    sendMessage(value) {
      const message = new Message(value, 3000, "error");
      EventBus.$emit("showMessage", message);
    }
  },
  created() {
    this.getEconomics();
    this.getUserData();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="css">
.sticky-balance {
  position: fixed;
  width: 100%;
  max-width: 500px;
  margin-top: 6.8rem;
  top: 0;
  z-index: 1;
}
.cursor-help {
  cursor: help;
}
.tooltip-refund {
  position: relative;
}
.icon-tooltip {
  position: absolute;
  top: 0px;
  right: -15px;
  background-color: aliceblue;
  border-radius: 25px;
}
@media (min-width: 470px) {
  .icon-tooltip {
    right: 0px;
  }
}
</style>
